<template>
  <div id="wrapper">
    <Spinner :isLoading="isLoading" />
    <div class="login-logo">
      <h1>
        <img src="/common/img/logo.png" alt="nanacara for Doctor" height="40" />
      </h1>
      <div style="margin-top: 35px">
        <h2>{{ $t("verify_code.title") }}</h2>
        <h2>{{ $t("verify_code.description") }}</h2>
        <h3 style="white-space: pre; text-align: center">
          {{ $t("verify_code.note") }}
        </h3>
      </div>
    </div>
    <div id="login-wrap">
      <div>
        <form @submit.prevent="onVerify()" method="post">
          <p class="mb20">確認コード</p>
          <input type="text" class="mb10" v-model="code" inputmode="numeric"
          oninput="this.value = this.value.replace(/[^0-9]/g, '');"
          maxlength="6"/>
          <div v-if="submitted && $v.code.$error">
            <p class="error-txt mb20" v-if="!$v.code.required">{{ $t('please_enter_the_verification_code') }}</p>
          </div>
          <p class="error-txt mb20" v-if="errorInputCode != '' && submitted">
            {{ errorInputCode }}
          </p>
          <div class="group-button" style="margin-top: 3em">
            <button class="btn-base w-100" type="submit">
              <a>
                <p>{{ $t("login") }}</p>
              </a>
            </button>
          </div>
        </form>
        <button class="btn-base w-100" @click="onResendMFA" style="background: white; margin-top: 10px">
          <a><p style="color: #ffa300">認証コードを再送信する</p></a>
        </button>
      </div>
    </div>

    <div id="modal">
      <b-modal
        id="modal-error"
        centered
        :hide-header="true"
        :hide-footer="true"
        class="modal-content"
      >
        <div class="modal-inner">
          <p class="modal-ttl" v-if="!errorVerifyCode">
            {{ $t("verify_code.resend_code_title") }}
          </p>
          <p
            class="modal-txt-error mb50"
            v-html="
              errorVerifyCode
                ? errorVerifyCode
                : $t('verify_code.resend_code_content')
            "
          ></p>
          <div class="btn-base pos-center">
            <a href="javascript:;" class="modal-close" @click="handleModal">
              <p>{{ $t("ok") }}</p>
            </a>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<style scoped>
h2 {
  font-size: 24px;
  font-weight: 600;
  margin-top: 20px;
}

h3 {
  font-size: 18px;
  font-weight: 500;
  margin-top: 50px;
}

.btn-base {
  border: solid #ffa300;
}
</style>
<script>
import { mapState } from "vuex";
import Footer from "@/js/components/Footer.vue";
import { BModal, VBModal, BButton } from "bootstrap-vue";
import { isLogin, setLogRocket } from "@/js/commons/commons";
import { required } from "vuelidate/lib/validators";
import Spinner from "@/js/components/Spinner";
import DeviceInfo from "@/js/commons/CheckDeviceLoginHelper";

export default {
  data() {
    return {
      code: "",
      isLoading: false,
      submitted: false,
      DeviceInfo,
    };
  },
  validations: {
    code: { required },
  },
  computed: {
    ...mapState({
      resetInfo: (state) => state.auth.resetInfo,
      session: (state) => state.auth.session,
      errorVerifyCode: (state) => state.auth.errorVerifyCode,
      errorInputCode: (state) => state.auth.errorInputCode
    }),
  },
  mounted() {
    if (this.resetInfo.email == "" || this.resetInfo.password == "" || this.session == "") {
      this.$router.push("/login");
    }
  },
  methods: {
    handleModal() {
      this.$bvModal.hide("modal-error");
      if (this.errorVerifyCode != "") {
        this.$router.push("/login");
      }
    },
    async onVerify() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$error) return;
      else {
        window.localStorage.setItem("isLogout", false);
        let params = {
          email: this.$store.state.auth.resetInfo.email,
          code: this.code,
          session: this.$store.state.auth.session,
          device_token: this.$store.state.auth.fcmToken,
        };
        setLogRocket(this.$store.state.auth.resetInfo.email);
        this.isLoading = true;
        await this.$store.dispatch("auth/verifyMfa", params);
        this.isLoading = false;
        if (this.errorInputCode == "" && this.errorVerifyCode == "") {
          if (!this.$route.query.hasOwnProperty("continue")) {
            this.$router.push('/').catch(() => { })
          } else {
            this.$router.push(decodeURIComponent(this.$route.query.continue)).catch(() => { })
          }
          await this.$store.dispatch("auth/getDoctorInfo")
          await this.$store.dispatch("auth/checkLoginDevice", this.DeviceInfo.getDeviceInfo())
        } else {
          return;
        }
      }
    },
    async onResendMFA() {
      let params = {
        email: this.$store.state.auth.resetInfo.email,
        password: this.$store.state.auth.resetInfo.password,
      };
      this.isLoading = true;
      await this.$store.dispatch("auth/login", params);
      this.isLoading = false;
      this.$bvModal.show("modal-error");
    },
  },
  components: {
    Footer,
    Spinner,
  },
  directives: { BModal, VBModal, BButton },
  watch: {
    errorVerifyCode: function (newVal, oldVal) {
      if (newVal != "") {
        this.$bvModal.show("modal-error");
      }
    },
    "code": function () {
      if (!this.code) {
        this.$store.dispatch("auth/clearErrMessage");
      }
    },
  },
};
</script>
